import { testimonials } from "@/mocks/gossip";

export default function TestimonialSection() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="max-w-2xl mx-auto text-center">
        <p className="inline-flex items-center gap-2 text-xs font-label tracking-[0.2em] uppercase text-primary-600 mb-3">
          <span className="w-6 h-px bg-primary-500 inline-block"></span>
          Voices
          <span className="w-6 h-px bg-primary-500 inline-block"></span>
        </p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">吃瓜人的真实反馈</h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
          来自长期关注热点的读者，他们更在意画面是否完整、时间线是否清楚。
        </p>
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {testimonials.map((item) => (
          <figure
            key={item.name}
            className="flex flex-col bg-background-50 border border-background-200 rounded-lg p-5 hover:border-primary-300 transition-colors"
          >
            <i className="ri-double-quotes-l text-2xl text-accent-500" aria-hidden="true"></i>
            <blockquote className="mt-3 text-sm text-foreground-700 leading-relaxed flex-1">
              {item.text}
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-3 pt-4 border-t border-background-200">
              <span className="w-10 h-10 rounded-full overflow-hidden bg-background-200 shrink-0">
                <img
                  src={item.avatar}
                  alt={`${item.name} 的头像`}
                  title={`${item.name} - 用户反馈`}
                  className="w-full h-full object-cover"
                />
              </span>
              <span className="min-w-0">
                <span className="block text-sm font-medium text-foreground-900 truncate">{item.name}</span>
                <span className="block text-xs text-foreground-500 truncate">{item.role}</span>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}